/* eslint-disable */
// ─── Verified mark ────────────────────────────────────────────────────────────
// The filled scalloped badge used by X, Instagram and Meta. Drawn rather than
// taken from an icon set because the recognisable version is SOLID — a filled
// twelve-lobed rosette with a white tick knocked out of it. Lucide's BadgeCheck
// is the outline variant, which reads as a generic "approved" stamp instead of
// the verification mark people already know.
//
// Two forms:
//   <VerifiedMark />              the badge alone, for tight spots
//   <VerifiedBadge label />       badge + VERIFIED pill, for photo overlays
//
// On photos the pill is a SOLID fill with a shadow. A translucent tint there
// borrows its colour from the image behind it — which is how the old badge
// ended up looking brown over a warm-toned studio photo.
const BLUE = "#1D9BF0";

export function VerifiedMark({ size = 16, color = BLUE, tick = "#fff", style, title = "Verified" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label={title}
      style={{ display: "block", flexShrink: 0, ...style }}>
      <title>{title}</title>
      {/* The rosette and the tick are both FILLED paths, not strokes. A stroked
          tick thins out and goes grey at 11px, which is the size this renders at
          on a card; a filled one stays solid. */}
      <path
        fill={color}
        d="M22.25 12c0-1.43-.88-2.67-2.19-3.34.46-1.39.2-2.9-.81-3.91s-2.52-1.27-3.91-.81C14.67 2.63 13.43 1.75 12 1.75s-2.67.88-3.34 2.19c-1.39-.46-2.9-.2-3.91.81s-1.27 2.52-.81 3.91c-1.31.67-2.19 1.91-2.19 3.34s.88 2.67 2.19 3.34c-.46 1.39-.2 2.9.81 3.91s2.52 1.27 3.91.81c.67 1.31 1.91 2.19 3.34 2.19s2.67-.88 3.34-2.19c1.39.46 2.9.2 3.91-.81s1.27-2.52.81-3.91c1.31-.67 2.19-1.91 2.19-3.34z"
      />
      <path
        fill={tick}
        d="M10.54 16.2L6.8 12.46l1.41-1.42 2.26 2.26 4.8-5.23 1.47 1.36-6.2 6.77z"
      />
    </svg>
  );
}

export default function VerifiedBadge({
  size = 12,
  label = true,
  text = "Verified",
  onPhoto = true,
  style,
}) {
  if (!label) return <VerifiedMark size={size + 4} />;
  return (
    <span
      title="Verified school"
      style={{
        display: "inline-flex", alignItems: "center", gap: 5,
        padding: "4px 10px 4px 6px", borderRadius: 20,
        background: onPhoto ? BLUE : "rgba(29,155,240,0.1)",
        color: onPhoto ? "#fff" : BLUE,
        border: onPhoto ? "1px solid rgba(255,255,255,0.3)" : "1px solid rgba(29,155,240,0.25)",
        boxShadow: onPhoto ? "0 2px 8px rgba(0,0,0,0.25)" : "none",
        fontSize: 10, letterSpacing: 1.2, textTransform: "uppercase", fontWeight: 700,
        whiteSpace: "nowrap", lineHeight: 1,
        ...style,
      }}
    >
      <VerifiedMark size={size + 2} color={onPhoto ? "#fff" : BLUE} tick={onPhoto ? BLUE : "#fff"} />
      {text}
    </span>
  );
}
